import SectionHeader from '../../../../components/SectionHeader/SectionHeader';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import Section from '../Section';
import PurchasesList from './PurchasesList';
import CardRowCard from '../../../../components/CardRow/CardRowCard';
import CardRow from '../../../../components/CardRow/CardRow';
import PropTypes from 'prop-types';

const Purchases = ({ customerId }) => {
  return (
    <Section>
      <SectionHeader>
        <FormattedMessage id={'app.lastPurchaseSteps.label'} />
      </SectionHeader>
      <CardRow>
        <CardRowCard>
          <PurchasesList customerId={customerId} />
        </CardRowCard>
      </CardRow>
    </Section>
  );
};

Purchases.propTypes = {
  customerId: PropTypes.number,
};

export default Purchases;
